function classes(...values) {
  return values.filter(Boolean).join(' ')
}

export function Attachment({ state = 'done', size = 'default', orientation = 'horizontal', className = '', ...props }) {
  return <article data-slot="attachment" data-state={state} data-size={size} data-orientation={orientation} className={classes('shadcn-attachment', className)} {...props}/>
}

export function AttachmentGroup({ className = '', ...props }) {
  return <div data-slot="attachment-group" className={classes('shadcn-attachment-group', className)} {...props}/>
}

export function AttachmentMedia({ variant = 'icon', className = '', ...props }) {
  return <div data-slot="attachment-media" data-variant={variant} className={classes('shadcn-attachment-media', className)} {...props}/>
}

export function AttachmentContent({ className = '', ...props }) {
  return <div data-slot="attachment-content" className={classes('shadcn-attachment-content', className)} {...props}/>
}

export function AttachmentTitle({ className = '', ...props }) {
  return <strong data-slot="attachment-title" className={classes('shadcn-attachment-title', className)} {...props}/>
}

export function AttachmentDescription({ className = '', ...props }) {
  return <span data-slot="attachment-description" className={classes('shadcn-attachment-description', className)} {...props}/>
}

export function AttachmentActions({ className = '', ...props }) {
  return <div data-slot="attachment-actions" className={classes('shadcn-attachment-actions', className)} {...props}/>
}

export function AttachmentAction({ className = '', type = 'button', ...props }) {
  return <button data-slot="attachment-action" type={type} className={classes('shadcn-attachment-action', className)} {...props}/>
}

export function AttachmentTrigger({ className = '', type = 'button', ...props }) {
  return <button data-slot="attachment-trigger" type={type} className={classes('shadcn-attachment-trigger', className)} {...props}/>
}
